import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { SurveyHome } from '@/models/survey';
import { calculateTimeLeft, calculateTimePercentage, getTimeBackgroundColor, TIME_UNITS } from '@/utils/timeUtils';
import type { TimeUnit } from '../types';
const parseTimeUnits = (timeLeft: number, t: (key: string, options?: {
  count?: number;
}) => string): TimeUnit[] => {
  const days = Math.floor(timeLeft / TIME_UNITS.DAY);
  const hours = Math.floor(timeLeft % TIME_UNITS.DAY / TIME_UNITS.HOUR);
  const minutes = Math.floor(timeLeft % TIME_UNITS.HOUR / TIME_UNITS.MINUTE);
  return [{
    value: days,
    label: t('time.day', {
      count: days
    }),
    show: days > 0
  }, {
    value: hours,
    label: t('time.hour', {
      count: hours
    }),
    show: hours > 0
  }, {
    value: minutes,
    label: t('time.minute', {
      count: minutes
    }),
    show: minutes >= 0
  }];
};
export const CountDownRenderCell = (row: SurveyHome) => {
  const {
    t
  } = useTranslation();
  const countDownDate = useMemo(() => dayjs(row.expires_at).valueOf(), [row.expires_at]);
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(row.expires_at ?? ''));
  const timeUnits = useMemo(() => parseTimeUnits(timeLeft, t), [timeLeft, t]);
  const isExpired = timeLeft <= 0;
  const timePercentage = useMemo(() => calculateTimePercentage(row.expires_at, row.created_at), [row.expires_at, row.created_at]);
  const timeStyle = useMemo(() => getTimeBackgroundColor(timePercentage), [timePercentage]);
  useEffect(() => {
    const interval = setInterval(() => {
      const newTimeLeft = countDownDate - Date.now();
      setTimeLeft(newTimeLeft);
    }, TIME_UNITS.SECOND);
    return () => clearInterval(interval);
  }, [countDownDate]);
  if (isExpired) {
    return <span className='text-sm text-gray-400'>
            {t('survey.expiredLabel')}
         </span>;
  }
  return <table className='mt-2 w-auto border-separate border-spacing-x-2 border-spacing-y-0.5'>
         <tbody>
            <tr>
               {timeUnits.map(({
          value,
          show
        }, index) => show ? <td key={index} className='rounded-md border p-0 text-center' style={{
          backgroundColor: timeStyle.backgroundColor,
          borderColor: timeStyle.borderColor
        }}>
                        <span className='rounded px-2 py-1 text-xs font-semibold' style={{
            color: timeStyle.color
          }}>
                           {value}
                        </span>
                     </td> : null)}
            </tr>
            <tr>
               {timeUnits.map(({
          label,
          show: show_0
        }, index_0) => show_0 ? <td className='p-0 text-center' key={index_0}>
                        <span className='text-xs opacity-70'>{label}</span>
                     </td> : null)}
            </tr>
         </tbody>
      </table>;
};